export default __webpack_public_path__ + "static/media/header-container-blue.c259c0fe.png";